import React, { useEffect, useState } from 'react';
import { useParams } from 'react-router-dom';
import { supabase } from '../supabaseClient';

const WaIcon = ({ size = 6 }) => (
  <svg className={`w-${size} h-${size}`} fill="currentColor" viewBox="0 0 24 24">
    <path d="M17.472 14.382c-.297-.149-1.758-.867-2.03-.967-.273-.099-.471-.148-.67.15-.197.297-.767.966-.94 1.164-.173.199-.347.223-.644.075-.297-.15-1.255-.463-2.39-1.475-.883-.788-1.48-1.761-1.653-2.059-.173-.297-.018-.458.13-.606.134-.133.298-.347.446-.52.149-.174.198-.298.298-.497.099-.198.05-.371-.025-.52-.075-.149-.669-1.612-.916-2.207-.242-.579-.487-.5-.669-.51-.173-.008-.371-.01-.57-.01-.198 0-.52.074-.792.372-.272.297-1.04 1.016-1.04 2.479 0 1.462 1.065 2.875 1.213 3.074.149.198 2.096 3.2 5.077 4.487.709.306 1.262.489 1.694.625.712.227 1.36.195 1.871.118.571-.085 1.758-.719 2.006-1.413.248-.694.248-1.289.173-1.413-.074-.124-.272-.198-.57-.347m-5.421 7.403h-.004a9.87 9.87 0 01-5.031-1.378l-.361-.214-3.741.982.998-3.648-.235-.374a9.86 9.86 0 01-1.51-5.26c.001-5.45 4.436-9.884 9.888-9.884 2.64 0 5.122 1.03 6.988 2.898a9.825 9.825 0 012.893 6.994c-.003 5.45-4.437 9.884-9.885 9.884m8.413-18.297A11.815 11.815 0 0012.05 0C5.495 0 .16 5.335.157 11.892c0 2.096.547 4.142 1.588 5.945L.057 24l6.305-1.654a11.882 11.882 0 005.683 1.448h.005c6.554 0 11.89-5.335 11.893-11.893a11.821 11.821 0 00-3.48-8.413z"/>
  </svg>
);

const ALL_SERVICES = [
  { id: 'mantenimiento', icon: '🔧', title: 'Mantenimiento Preventivo', desc: 'Cambio de aceite, filtros y revision general del vehiculo.' },
  { id: 'mecanica',      icon: '⚙️', title: 'Mecanica General',         desc: 'Motor, transmision, frenos y sistema de suspension.' },
  { id: 'electrico',     icon: '⚡', title: 'Sistema Electrico',         desc: 'Diagnostico computarizado y reparacion electrica.' },
  { id: 'aireacond',     icon: '❄️', title: 'Aire Acondicionado',        desc: 'Carga de gas, limpieza y reparacion del sistema.' },
  { id: 'diagnostico',   icon: '🔍', title: 'Diagnostico Profesional',   desc: 'Scanner de ultima generacion para detectar fallas.' },
  { id: 'lavado',        icon: '✨', title: 'Lavado y Detailing',         desc: 'Limpieza interior y exterior con productos premium.' },
  { id: 'alineacion',    icon: '🎯', title: 'Alineacion y Balanceo',      desc: 'Correccion de angulos y equilibrio de ruedas.' },
  { id: 'llantas',       icon: '🔵', title: 'Llantas y Rines',            desc: 'Venta, montaje y reparacion de llantas.' },
  { id: 'latoneria',     icon: '🎨', title: 'Latoneria y Pintura',        desc: 'Reparacion de golpes y pintura profesional.' },
  { id: 'frenos',        icon: '🛑', title: 'Sistema de Frenos',          desc: 'Pastillas, discos, liquido y calibradores.' },
  { id: 'transmision',   icon: '🔩', title: 'Transmision',                desc: 'Caja automatica, mecanica y diferencial.' },
  { id: 'suspension',    icon: '🚗', title: 'Suspension y Direccion',     desc: 'Amortiguadores, rotulas y direccion hidraulica.' },
  { id: 'vidrios',       icon: '🪟', title: 'Vidrios y Polarizado',       desc: 'Instalacion y reparacion de vidrios.' },
  { id: 'escape',        icon: '💨', title: 'Escape y Turbo',             desc: 'Sistema de escape, catalizadores y turbo.' },
  { id: 'bateria',       icon: '🔋', title: 'Baterias',                   desc: 'Venta, carga y mantenimiento de baterias.' },
];

// Convierte hex a rgb para poder usar con opacidad
const hexToRgb = (hex) => {
  const r = parseInt(hex.slice(1, 3), 16);
  const g = parseInt(hex.slice(3, 5), 16);
  const b = parseInt(hex.slice(5, 7), 16);
  return `${r}, ${g}, ${b}`;
};

const WorkshopLanding = () => {
  const { slug } = useParams();
  const [workshop, setWorkshop] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const fetchWorkshopData = async () => {
      try {
        const { data, error } = await supabase
          .from('workshops')
          .select('*')
          .eq('slug', slug)
          .single();
        if (error) throw error;
        setWorkshop(data);
      } catch (error) {
        console.error('Error cargando el taller:', error.message);
      } finally {
        setLoading(false);
      }
    };
    fetchWorkshopData();
  }, [slug]);

  if (loading) return (
    <div className="min-h-screen bg-gray-900 flex items-center justify-center">
      <div className="text-center">
        <div className="w-12 h-12 border-4 border-blue-500 border-t-transparent rounded-full animate-spin mx-auto mb-4"></div>
        <p className="text-white text-lg font-medium">Cargando tu taller...</p>
      </div>
    </div>
  );

  if (!workshop) return (
    <div className="min-h-screen bg-gray-900 flex items-center justify-center">
      <p className="text-white text-lg">Taller no encontrado.</p>
    </div>
  );

  const primary   = workshop.brand_color_primary   || '#1e293b';
  const secondary = workshop.brand_color_secondary || '#3b82f6';
  const heroImg   = workshop.hero_image_url || 'https://images.unsplash.com/photo-1486262715619-67b85e0b08d3?w=1920&q=80';
  const agendaUrl = `https://agenda.filtrosyaceitesjm.com/login?workshopId=${workshop.id}`;
  const waNum     = workshop.whatsapp ? workshop.whatsapp.replace(/\D/g, '') : null;
  const waUrl     = waNum ? `https://wa.me/${waNum}` : null;
  const fmt       = (t) => t ? t.slice(0, 5) : '';

  const rgbPrimary   = hexToRgb(primary);
  const rgbSecondary = hexToRgb(secondary);

  // Servicios seleccionados
  const savedIds = Array.isArray(workshop.services) && workshop.services.length > 0
    ? workshop.services : null;
  const SERVICES = savedIds
    ? ALL_SERVICES.filter(s => savedIds.includes(s.id))
    : ALL_SERVICES.slice(0, 6);

  // Grid adaptativo al numero de servicios
  const count = SERVICES.length;
  const gridClass = count <= 3
    ? 'grid-cols-1 sm:grid-cols-3'
    : count <= 6
      ? 'grid-cols-2 md:grid-cols-3'
      : count <= 9
        ? 'grid-cols-2 md:grid-cols-3 lg:grid-cols-3'
        : 'grid-cols-2 md:grid-cols-4 lg:grid-cols-5';
  const cardPad = count >= 10 ? 'p-4' : 'p-6';

  return (
    <div className="min-h-screen bg-white font-sans" id="ws-root">

      {/* ── CSS DINAMICO CON LOS COLORES DEL TALLER ── */}
      <style>{`
        /* Variables de marca */
        #ws-root {
          --p: ${primary};
          --s: ${secondary};
          --p-rgb: ${rgbPrimary};
          --s-rgb: ${rgbSecondary};
        }

        /* Tarjetas de servicio */
        .ws-card {
          border: 2px solid transparent;
          transition: all 0.25s ease;
          background: white;
        }
        .ws-card:hover {
          border-color: rgba(${rgbSecondary}, 0.6);
          box-shadow: 0 12px 32px rgba(${rgbSecondary}, 0.18);
          transform: translateY(-3px);
        }

        /* Icono dentro de la tarjeta */
        .ws-icon-bg {
          background-color: rgba(${rgbPrimary}, 0.10);
          transition: background-color 0.25s ease;
        }
        .ws-card:hover .ws-icon-bg {
          background-color: rgba(${rgbSecondary}, 1);
        }

        /* Titulo de tarjeta al hover */
        .ws-card:hover .ws-card-title {
          color: ${secondary};
        }

        /* Etiqueta de seccion */
        .ws-label {
          color: ${secondary};
        }

        /* Barra decorativa bajo titulos */
        .ws-bar {
          background: linear-gradient(90deg, ${secondary}, ${primary});
        }

        /* Boton outline */
        .ws-btn-outline {
          border: 2px solid rgba(255,255,255,0.45);
          backdrop-filter: blur(4px);
          transition: background-color 0.2s;
        }
        .ws-btn-outline:hover {
          background-color: rgba(255,255,255,0.12);
        }

        /* Stat card */
        .ws-stat {
          border: 1.5px solid rgba(${rgbSecondary}, 0.20);
          transition: all 0.2s ease;
        }
        .ws-stat:hover {
          border-color: rgba(${rgbSecondary}, 0.55);
          box-shadow: 0 4px 16px rgba(${rgbSecondary}, 0.12);
        }
        .ws-stat-num {
          color: ${secondary};
        }

        /* CTA strip */
        .ws-cta {
          background: linear-gradient(135deg, ${primary} 0%, ${secondary} 100%);
        }

        /* Footer tint */
        .ws-footer {
          background: linear-gradient(180deg, #0f172a 0%, #111827 100%);
          border-top: 3px solid ${secondary};
        }

        /* Nav scrolled */
        .ws-nav {
          background-color: ${primary};
          transition: box-shadow 0.3s;
        }

        /* Scroll suave */
        html { scroll-behavior: smooth; }
      `}</style>

      {/* ─── NAV ─── */}
      <nav className="ws-nav sticky top-0 z-50 shadow-xl">
        <div className="max-w-6xl mx-auto px-5 py-4 flex items-center justify-between">
          <span className="text-white font-black italic uppercase tracking-tight text-xl">{workshop.name}</span>
          <div className="flex items-center gap-3">
            {waUrl && (
              <a href={waUrl} target="_blank" rel="noreferrer"
                className="ws-btn-outline hidden sm:flex items-center gap-2 px-4 py-2 rounded-full text-white text-sm font-semibold">
                <WaIcon size={4} /> WhatsApp
              </a>
            )}
            <a href={agendaUrl}
              className="px-5 py-2.5 rounded-full text-white text-sm font-black shadow-lg hover:opacity-90 transition-all hover:scale-105"
              style={{ backgroundColor: secondary }}>
              Agendar Cita →
            </a>
          </div>
        </div>
      </nav>

      {/* ─── HERO ─── */}
      <section
        className="relative min-h-screen flex items-center justify-center text-center overflow-hidden"
        style={{
          backgroundImage: `url(${heroImg})`,
          backgroundSize: 'cover',
          backgroundPosition: 'center',
          backgroundAttachment: 'fixed',
        }}
      >
        {/* Overlay con los colores exactos del taller */}
        <div className="absolute inset-0" style={{
          background: `linear-gradient(135deg,
            rgba(${rgbPrimary}, 0.93) 0%,
            rgba(${rgbPrimary}, 0.75) 40%,
            rgba(0,0,0,0.60) 100%)`
        }} />

        <div className="relative z-10 max-w-4xl mx-auto px-6 py-32">
          {/* Badge live */}
          <div className="inline-flex items-center gap-2 px-4 py-1.5 rounded-full border border-white/20 text-white/90 text-sm font-medium mb-8"
            style={{ backgroundColor: `rgba(${rgbSecondary}, 0.20)` }}>
            <span className="w-2 h-2 rounded-full bg-green-400 animate-pulse inline-block"></span>
            {workshop.city}, Colombia &mdash; Agenda disponible ahora
          </div>

          <h1 className="text-4xl md:text-6xl font-black text-white mb-6 leading-tight drop-shadow-lg">
            {workshop.hero_title || `Expertos en mecanica automotriz en ${workshop.city}`}
          </h1>
          <p className="text-lg md:text-xl text-white/80 mb-10 max-w-2xl mx-auto leading-relaxed">
            {workshop.hero_description || `En ${workshop.name} cuidamos tu vehiculo con la mejor tecnologia y garantia en cada trabajo.`}
          </p>

          <div className="flex flex-col sm:flex-row items-center justify-center gap-4">
            <a href={agendaUrl}
              className="w-full sm:w-auto px-9 py-4 rounded-full text-white font-black text-lg shadow-2xl hover:scale-105 transition-transform"
              style={{ backgroundColor: secondary }}>
              Agendar Cita Online →
            </a>
            {waUrl && (
              <a href={waUrl} target="_blank" rel="noreferrer"
                className="ws-btn-outline w-full sm:w-auto flex items-center justify-center gap-2 px-9 py-4 rounded-full text-white font-bold text-lg">
                <WaIcon size={5} /> Escribir por WhatsApp
              </a>
            )}
          </div>

          <div className="mt-16 text-white/40 text-xs animate-bounce">↓ Ver servicios</div>
        </div>
      </section>

      {/* ─── STATS ─── */}
      <section className="py-10 bg-gray-50 border-b border-gray-100">
        <div className="max-w-5xl mx-auto px-5 grid grid-cols-2 md:grid-cols-4 gap-4">
          {[
            { val: '100%', label: 'Servicio Garantizado' },
            { val: 'Hoy',  label: 'Atencion disponible' },
            { val: '✓',    label: 'Tecnicos Certificados' },
            { val: '0$',   label: 'Diagnostico incluido' },
          ].map((s, i) => (
            <div key={i} className="ws-stat bg-white rounded-2xl px-5 py-4 text-center">
              <div className="ws-stat-num text-2xl font-black mb-0.5">{s.val}</div>
              <div className="text-gray-400 text-xs font-medium">{s.label}</div>
            </div>
          ))}
        </div>
      </section>

      {/* ─── SERVICIOS ─── */}
      <section className="py-20 bg-white">
        <div className="max-w-6xl mx-auto px-5">
          <div className="text-center mb-12">
            <span className="ws-label text-xs font-black uppercase tracking-widest">Lo que hacemos</span>
            <h2 className="text-3xl md:text-4xl font-black text-gray-900 mt-2 mb-3">Nuestros Servicios</h2>
            <div className="ws-bar h-1 w-14 mx-auto rounded-full"></div>
            <p className="text-gray-400 mt-4 max-w-xl mx-auto text-sm">
              Atencion profesional para todo tipo de vehiculos con equipos de diagnostico de ultima generacion.
            </p>
          </div>

          <div className={`grid ${gridClass} gap-5`}>
            {SERVICES.map((s) => (
              <div key={s.id} className={`ws-card rounded-2xl ${cardPad} shadow-sm cursor-default`}>
                <div className="ws-icon-bg w-12 h-12 rounded-xl flex items-center justify-center mb-4">
                  <span className="text-2xl">{s.icon}</span>
                </div>
                <h3 className="ws-card-title font-bold text-gray-900 text-sm mb-1.5 transition-colors">{s.title}</h3>
                <p className="text-gray-400 text-xs leading-relaxed">{s.desc}</p>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* ─── CTA BANNER ─── */}
      <section className="ws-cta py-20 px-5 text-center">
        <div className="max-w-3xl mx-auto">
          <h2 className="text-3xl md:text-4xl font-black text-white mb-4">
            Listo para agendar tu cita?
          </h2>
          <p className="text-white/80 mb-8 text-lg">
            Agenda en linea en menos de 2 minutos. Sin llamadas, sin esperas.
          </p>
          <a href={agendaUrl}
            className="inline-block px-10 py-4 bg-white rounded-full font-black text-lg hover:scale-105 transition-transform shadow-2xl"
            style={{ color: primary }}>
            Reservar mi Cita Ahora →
          </a>
        </div>
      </section>

      {/* ─── FOOTER ─── */}
      <footer className="ws-footer text-gray-400 py-14 px-5">
        <div className="max-w-6xl mx-auto">
          <div className="grid grid-cols-1 md:grid-cols-3 gap-8 mb-10">

            {/* Col 1 — brand */}
            <div>
              <span className="text-white font-black italic uppercase tracking-tight text-xl block mb-3">
                {workshop.name}
              </span>
              <p className="text-sm leading-relaxed text-gray-500">
                {workshop.footer_tagline || `Tu taller de confianza en ${workshop.city}. Calidad y garantia en cada servicio.`}
              </p>
              {/* Servicios mini-lista */}
              {SERVICES.length > 0 && (
                <div className="mt-4 flex flex-wrap gap-1.5">
                  {SERVICES.slice(0, 4).map(s => (
                    <span key={s.id}
                      className="text-xs px-2.5 py-1 rounded-full font-medium text-white"
                      style={{ backgroundColor: `rgba(${rgbSecondary}, 0.30)` }}>
                      {s.icon} {s.title.split(' ')[0]}
                    </span>
                  ))}
                  {SERVICES.length > 4 && (
                    <span className="text-xs px-2.5 py-1 rounded-full font-medium text-gray-500 border border-gray-700">
                      +{SERVICES.length - 4} mas
                    </span>
                  )}
                </div>
              )}
            </div>

            {/* Col 2 — contacto */}
            <div>
              <h4 className="text-white font-bold mb-4 text-xs uppercase tracking-widest">Contacto</h4>
              <ul className="space-y-2 text-sm">
                <li>📞 {workshop.phone}</li>
                <li>📍 {workshop.address}, {workshop.city}</li>
                {workshop.opening_time && (
                  <li>🕐 {fmt(workshop.opening_time)} – {fmt(workshop.closing_time)}</li>
                )}
              </ul>
              {waUrl && (
                <a href={waUrl} target="_blank" rel="noreferrer"
                  className="inline-flex items-center gap-2 mt-4 px-4 py-2 bg-green-600 hover:bg-green-500 text-white text-xs font-bold rounded-full transition-colors">
                  <WaIcon size={4} /> Escribenos al WhatsApp
                </a>
              )}
            </div>

            {/* Col 3 — CTA */}
            <div className="md:text-right">
              <a href={agendaUrl}
                className="inline-block px-7 py-3.5 rounded-full text-white font-bold text-sm shadow-lg hover:opacity-90 transition-opacity mb-5"
                style={{ backgroundColor: secondary }}>
                Agendar mi Cita →
              </a>
              <p className="text-xs text-gray-600">
                Potenciado por <span className="font-bold" style={{ color: secondary }}>Garaje Pro 360</span>
              </p>
            </div>
          </div>

          <div className="border-t border-gray-800 pt-6 text-center text-xs text-gray-600">
            © {new Date().getFullYear()} {workshop.name} &middot; Todos los derechos reservados &middot; {workshop.city}, Colombia
          </div>
        </div>
      </footer>

      {/* ─── WhatsApp FAB ─── */}
      {waUrl && (
        <a href={waUrl} target="_blank" rel="noreferrer"
          className="fixed bottom-6 right-6 w-14 h-14 bg-green-500 hover:bg-green-400 rounded-full flex items-center justify-center shadow-2xl transition-transform hover:scale-110 z-50 text-white">
          <WaIcon size={7} />
        </a>
      )}
    </div>
  );
};

export default WorkshopLanding;
